import SearchBox from '@root/modules/Sellers/Inquiry/components/Search';
import DataPicker from '@root/modules/Warehouse/Inquiry/components/wrap-action/DataPicker';
import DropdownAction from '@root/modules/Warehouse/Inquiry/components/wrap-action/DropdownAction';
import { Menu } from 'antd';

function WrapActionInven({
  getSelect,
  labelSelect,
  onChangeSearch,
  getDateValue,
  typeDrop,
  onSearchName
}: any) {
  const menu = [
    {
      id: 1,
      titleSelect: 'Select',
      list: (
        <Menu
          onClick={getSelect}
          items={[
            {
              label: 'Seller Name',
              key: 'name'
            },
            {
              label: 'Seller Email Address',
              key: 'email'
            }
          ]}
        />
      )
    }
  ];
  const menu2 = [
    {
      id: 1,
      titleSelect: 'Select',
      list: (
        <Menu
          onClick={getSelect}
          items={[
            {
              label: 'Product Name',
              key: 'productName'
            },
            {
              label: 'SKU',
              key: 'sku'
            }
          ]}
        />
      )
    }
  ];

  return (
    <div
      className="wrapActions"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '9px',
        marginBottom: '21px'
      }}
    >
      <DataPicker getDate={getDateValue} />
      {typeDrop === 'sell' ? (
        <>
          {menu.map((item) => {
            return (
              <DropdownAction
                key={item.id}
                titleSelect={labelSelect.label}
                list={item.list}
              />
            );
          })}
        </>
      ) : (
        <>
          {menu2.map((item) => {
            return (
              <DropdownAction
                key={item.id}
                titleSelect={labelSelect.label}
                list={item.list}
              />
            );
          })}
        </>
      )}

      {/* <SearchInput /> */}
      <SearchBox
        type="false"
        onChange={(e: any) => onChangeSearch('Value Search', e.target.value)}
        // onSearchName={onSearchName}
      />
    </div>
  );
}

export default WrapActionInven;
